<template>
  <div id="custom-lti-dash">
    <iframe :src="getSourceUrl" class="iframe-fit"></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CustomLtiDash',
  computed: {
    ...mapGetters(['school']),
    getSourceUrl() {
      return _.get(this, 'school.config.customLtiDashUrl', '');
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-fit {
  width: 100%;
  height: calc(100vh - 51px);
  border: none;
}
</style>
